// extracted by mini-css-extract-plugin
export var description = "join-module--description--jPXoQ";
export var postscript = "join-module--postscript--wFkpc";
export var registrationBtnWrapper = "join-module--registration-btn-wrapper--GUwTs";
export var registerWrapper = "join-module--register-wrapper--hkU8f";